import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from 'hooks';
import { statuses } from 'constants/alarms';
import { generateFilterOptions } from 'utils';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AlarmStatusStyled from './AlarmStatusSelect.styled';

const AlarmStatusSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
}) => {
  const prevvalue = usePrevious(value);
  const prevpriorities = usePrevious(value);
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (prevvalue !== value || prevpriorities !== statuses) {
      const defaultVal = statuses.find((el) => el.label.toLowerCase() === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, statuses]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      id="alarm-status"
      data-cy="alarm-status-select"
      options={statuses}
      value={defaultValue}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option.label}
      onChange={(ev, val) => setFieldValue(name, val?.value)}
      getOptionSelected={(option, value) => option?.value === (value?.value || false)}
      renderInput={(params) => (
        <AlarmStatusStyled
          {...params}
          label={label}
          margin="normal"
          variant={variant}
          error={errors && errors[name] && touched && touched[name]}
          helperText={errors && errors[name] && touched && touched[name] && errors[name]}
        />
      )}
    />
  );
};

AlarmStatusSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

AlarmStatusSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Status',
};

export default AlarmStatusSelect;
